import React from "react";
import T from "i18n-react";
import Styles from "./styles.module.scss";

interface IVenueOrderTypeHeaderProps {
  title: string;
  svgImage: JSX.Element;
  selected?: boolean;
}

function VenueOrderTypeHeader({
  title,
  svgImage,
  selected,
}: IVenueOrderTypeHeaderProps) {
  return (
    <div
      data-component-name="VenuePageOrderTypeCollapse"
      className={
        selected
          ? Styles.SelectedVenueOrderTypeHeaderTitleDiv
          : Styles.VenueOrderTypeHeaderTitleDiv
      }
    >
      {svgImage}
      <T.p text={{ key: title }} />
    </div>
  );
}

export default VenueOrderTypeHeader;
